import UIComponent from '../../common/UIComponent';
import './index.css';
import DanmakuSetting from '../../component/danmakuSetting/index.js';

export default class Landscape extends UIComponent {
  constructor(elementId, interfaces, videoNode) {
    super(interfaces);
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.videoNode = videoNode;
    // this.interfaces.openBarrage();
    window.addEventListener(
      'onorientationchange' in window ? 'orientationchange' : 'resize',
      this.barrageComponent.bind(this),
      false
    );
    this.init();
    this.flg = false;
  }

  init() {
    this.brarageComponent = document.createElement('div');
    this.brarageComponent.setAttribute('class', 'h5vhallPlayer-brarage-component-Landscape');
    this.brarageComponent.style.display = 'none';

    this.brarageBtn = document.createElement('span');
    // this.brarageBtn.setAttribute("class", "vhallPlayer-brarage-btn open");
    this.brarageBtn.setAttribute(
      'class',
      'h5vhallPlayer-brarage-btn-Landscape vh-player-iconfont vh-player-line-player-barrageSettings'
    );
    this.brarageBtn.onclick = this.handleBtnClick.bind(this);

    this.verticalSliderPopup = document.createElement('div');
    this.verticalSliderPopup.setAttribute('class', 'h5vhallPlayer-brarage-popup-Landscape');

    this.brarageComponent.appendChild(this.brarageBtn);
    this.brarageComponent.appendChild(this.verticalSliderPopup);
    this.insertElement(this.elementId, this.brarageComponent);
    new DanmakuSetting(this.verticalSliderPopup, this.interfaces);

    this.videoNodeContainer = document.querySelector(this.videoNode);
    this.videoNodeContainer.addEventListener('click', () => {
      this.verticalSliderPopup.style.display = 'none';
    });
  }

  handleBtnClick() {
    if (this.verticalSliderPopup.style.display === 'block') {
      this.verticalSliderPopup.style.display = 'none';
    } else {
      this.h5definition_popup = this.videoNodeContainer.querySelector('.h5definition-popup');
      if (this.h5definition_popup && this.h5definition_popup.style.display === 'block') {
        this.h5definition_popup.style.display = 'none';
      }
      this.verticalSliderPopup.style.display = 'block';
    }
  }

  barrageComponent() {
    if (window.orientation == 180 || window.orientation == 0) {
      // alert("竖屏状态！")
      this.brarageComponent.style.display = 'none';
    }
    if (window.orientation == 90 || window.orientation == -90) {
      // alert("横屏状态！")
      if (this.interfaces.barrageState()) {
        this.brarageComponent.style.display = 'block';
      }
    }
  }
}
